/* eslint-disable max-len */
/* eslint-disable linebreak-style */
import i18next from 'i18next';
import { v4 as uuidV4 } from 'uuid';
import fixWebmDuration from 'webm-duration-fix';
import { getRoomName } from '../../../base/conference/functions';
import { MEDIA_TYPE } from '../../../base/media/constants';
import { getLocalTrack, getTrackState } from '../../../base/tracks/functions';
import { inIframe } from '../../../base/util/iframeUtils';
import { stopLocalVideoRecording } from '../../actions.any';
const getMimeType = () => {
    const possibleTypes = [
        /* 'video/mp4;codecs=h264',
        'video/webm;codecs=h264',
        'video/webm;codecs=vp9',
        'video/webm;codecs=vp8,opus' */
        'video/webm;codecs=vp8'
    ];
    for (const type of possibleTypes) {
        if (MediaRecorder.isTypeSupported(type)) {
            return type;
        }
    }
    throw new Error('No MIME Type supported by MediaRecorder');
};
const VIDEO_BIT_RATE = 2500000; // 2.5Mbps in bits
const MAX_SIZE = 1073741824; // 1GB in bytes
const brand = window.location.href.includes(".vianova.it") ? "vianova" : (window.location.href.includes(".kalliope.cloud") ? "kalliope" : "");
// Lazily initialize.
let preferredMediaType;
const LocalRecordingManager = {
    canvas: undefined,
    ctx: null,
    imageBrand: null,
    recordInterval: undefined,
    paintID: 0,
    recordingData: [],
    recorder: undefined,
    stream: undefined,
    audioContext: undefined,
    audioDestination: undefined,
    roomName: '',
    totalSize: MAX_SIZE,
    selfRecording: {
        on: false,
        withVideo: false
    },
    get mediaType() {
        if (this.selfRecording.on && !this.selfRecording.withVideo) {
            return 'audio/webm;';
        }
        if (!preferredMediaType) {
            preferredMediaType = getMimeType();
        }
        return preferredMediaType;
    },
    /**
     * Initializes audio context used for mixing audio tracks.
     *
     * @returns {void}
     */
    initializeAudioMixer() {
        this.audioContext = new AudioContext();
        this.audioDestination = this.audioContext.createMediaStreamDestination();
    },
    /**
     * Mixes multiple audio tracks to the destination media stream.
     *
     * @param {MediaStream} stream - The stream to mix.
     * @returns {void}
     * */
    mixAudioStream(stream) {
        if (stream.getAudioTracks().length > 0 && this.audioDestination) {
            this.audioContext?.createMediaStreamSource(stream).connect(this.audioDestination);
        }
    },
    /**
     * Adds audio track to the recording stream.
     *
     * @param {MediaStreamTrack} track - The track to be added.
     * @returns {void}
     */
    addAudioTrackToLocalRecording(track) {
        if (this.selfRecording.on) {
            return;
        }
        if (track) {
            const stream = new MediaStream([track]);
            this.mixAudioStream(stream);
        }
    },
    /**
     * Returns a filename based ono the Jitsi room name in the URL and timestamp.
     *
     * @returns {string}
     * */
    getFilename() {
        const now = new Date();
        const timestamp = now.toISOString();
        return `${this.roomName}_${timestamp}`;
    },
    /**
     * Saves local recording to file.
     *
     * @param {Array} recordingData - The recording data.
     * @param {string} filename - The name of the file.
     * @returns {void}
     * */
    async saveRecording(recordingData, filename) {
        // @ts-ignore
        const blob = await fixWebmDuration(new Blob(recordingData, { type: this.mediaType }));
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        const extension = this.mediaType.slice(this.mediaType.indexOf('/') + 1, this.mediaType.indexOf(';'));
        a.style.display = 'none';
        a.href = url;
        a.download = `${filename}.${extension}`;
        a.click();
    },
    /**
     * Stops local recording.
     *
     * @returns {void}
     * */
    stopLocalRecording() {
        if (this.recorder) {
            this.recorder.stop();
            this.recorder = undefined;
            this.audioContext = undefined;
            this.audioDestination = undefined;
            this.totalSize = MAX_SIZE;
            setTimeout(() => {
                if (this.recordingData.length > 0) {
                    this.saveRecording(this.recordingData, this.getFilename());
                }
            }, 1000);
        }
    },
    createLayer(canvas) {
        const layer = document.createElement('canvas');
        // @ts-ignore
        layer.width = canvas.width;
        // @ts-ignore
        layer.height = canvas.height;
        return layer.getContext('2d');
    },
    recordVideos() {
        this.imageBrand = new Image();
        if (brand == 'vianova') {
            this.imageBrand.src = '../../../../../images/logo-vianova-rec.png?versionid=223';
        }
        else if (brand == 'kalliope') {
            this.imageBrand.src = '../../../../../images/kalliope_watermark.png?versionid=223';
        }
        const paint = () => {
            const store = APP.store;
            const { local, remote, localScreenShare } = store.getState()['features/base/participants'];
            // eslint-disable-next-line max-len
            let videos;
            const elementWidth = 1280;
            const elementHeight = 720;
            const paddingX = 10;
            const paddingY = 10;
            let numElements = 1;
            let numColumns = 1;
            let numRows = 1;
            let whiteboardVideo = document.querySelector(".excalidraw__canvas"); // . classname,  # id
            if (whiteboardVideo === null || whiteboardVideo.width === 0) {
                // dal DOM recuperiamo tutti i video relativi a webcam accese,
                videos = Array.from(document.querySelectorAll('span.display-video video'));
                numElements = videos.length;
                numColumns = Math.ceil(Math.sqrt(numElements));
                numRows = Math.ceil(numElements / numColumns);
            }
            // @ts-ignore
            this.canvas.width = ((elementWidth + paddingX) * numColumns) + paddingX;
            // @ts-ignore
            this.canvas.height = ((elementHeight + paddingY) * numRows) + paddingY;
            let name;
            const layerParticipantName = this.createLayer(this.canvas);
            layerParticipantName.fillStyle = 'white';
            if (brand == 'vianova') {
                layerParticipantName.font = '18px Roboto';
                layerParticipantName.drawImage(this.imageBrand, 32, 20, 180, 25);
            }
            else if (brand == 'kalliope') {
                layerParticipantName.font = '16px Poppins';
                layerParticipantName.drawImage(this.imageBrand, 32, 20);
            }
            if (whiteboardVideo !== null && whiteboardVideo.width !== 0) {
                // @ts-ignore
                this.ctx.drawImage(whiteboardVideo, 0, 0, elementWidth, elementHeight);
            }
            else {
                for (let i = 0; i < numElements; i++) {
                    const elementX = ((i % numColumns) * (elementWidth + paddingX)) + paddingX;
                    const elementY = (Math.floor(i / numColumns) * (elementHeight + paddingY)) + paddingY;
                    name = '';
                    // @ts-ignore
                    if (videos[i].id === 'localVideo_container') {
                        name = local?.name;
                    }
                    else {
                        //in "videos" the videos are catalogued like this -> remoteVideo_remote-video-1, retrieving the id from the parent ( participant_76c8b9ce ), 
                        // then we go to retrieve the compound name like this #participant_76c8b9ce_name
                        // whether they are webcam videos or screenshares is indifferent...
                        // @ts-ignore
                        let parentId = document.querySelector("#" + videos[i].id)?.parentElement?.id;
                        name = document.querySelector("#" + parentId + "_name")?.textContent;
                    }
                    layerParticipantName.fillText(name, elementX + (elementWidth / 2) - (name.length * 2.5), elementY + (elementHeight * 0.98));
                    // @ts-ignore
                    this.ctx.drawImage(videos[i], elementX, elementY, elementWidth, elementHeight);
                }
            }
            this.ctx.drawImage(layerParticipantName.canvas, 0, 0);
            this.paintID = requestAnimationFrame(paint);
        };
        this.paintID = requestAnimationFrame(paint);
        const fps = 60;
        // @ts-ignore
        if ('captureStream' in this.canvas) {
            // @ts-ignore
            return this.canvas.captureStream(fps); //per tutti a parte safari
            // @ts-ignore
        }
        else if ('webkitCaptureStream' in this.canvas) {
            // @ts-ignore
            return this.canvas.webkitCaptureStream(fps);
        }
    },
    /**
     * Starts a local recording.
     *
     * @param {IStore} store - The redux store.
     * @param {boolean} onlySelf - Whether to record only self streams.
     * @returns {void}
     */
    async startLocalRecording(store, onlySelf) {
        const { dispatch, getState } = store;
        // @ts-ignore
        const supportsCaptureHandle = Boolean(navigator.mediaDevices.setCaptureHandleConfig) && !inIframe();
        const tabId = uuidV4();
        this.selfRecording.on = onlySelf;
        this.recordingData = [];
        this.roomName = getRoomName(getState()) ?? '';
        const tracks = getTrackState(getState());
        if (onlySelf) {
            let audioTrack = getLocalTrack(tracks, MEDIA_TYPE.AUDIO)?.jitsiTrack?.track;
            let videoTrack = getLocalTrack(tracks, MEDIA_TYPE.VIDEO)?.jitsiTrack?.track;
            if (!audioTrack) {
                APP.conference.muteAudio(false);
                setTimeout(() => APP.conference.muteAudio(true), 100);
                await new Promise(resolve => {
                    setTimeout(resolve, 100);
                });
            }
            if (videoTrack && videoTrack.readyState !== 'live') {
                videoTrack = undefined;
            }
            audioTrack = getLocalTrack(getTrackState(getState()), MEDIA_TYPE.AUDIO)?.jitsiTrack?.track;
            if (!audioTrack && !videoTrack) {
                throw new Error('NoLocalStreams');
            }
            this.selfRecording.withVideo = Boolean(videoTrack);
            const localTracks = [];
            audioTrack && localTracks.push(audioTrack);
            videoTrack && localTracks.push(videoTrack);
            this.stream = new MediaStream(localTracks);
        }
        else {
            if (supportsCaptureHandle) {
                // @ts-ignore
                navigator.mediaDevices.setCaptureHandleConfig({
                    handle: `JitsiMeet-${tabId}`,
                    permittedOrigins: ['*']
                });
            }
            const localAudioTrack = getLocalTrack(tracks, MEDIA_TYPE.AUDIO)?.jitsiTrack?.track;
            // Starting chrome 107, the recorder does not record any data if the audio stream has no tracks
            // To fix this we create a track for the local user(muted track)
            if (!localAudioTrack) {
                APP.conference.muteAudio(false);
                setTimeout(() => APP.conference.muteAudio(true), 100);
                await new Promise(resolve => {
                    setTimeout(resolve, 100);
                });
            }
            // handle no mic permission
            if (!getLocalTrack(getTrackState(getState()), MEDIA_TYPE.AUDIO)?.jitsiTrack?.track) {
                throw new Error('NoMicTrack');
            }
            const currentTitle = document.title;
            document.title = i18next.t('localRecording.selectTabTitle');
            this.canvas = document.createElement('canvas');
            (document.body || document.documentElement).appendChild(this.canvas);
            this.ctx = this.canvas.getContext('2d', { willReadFrequently: true });
            document.title = currentTitle;
            this.initializeAudioMixer();
            const allTracks = getTrackState(getState());
            allTracks.forEach((track) => {
                if (track.mediaType === MEDIA_TYPE.AUDIO) {
                    const audioTrack = track?.jitsiTrack?.track;
                    this.addAudioTrackToLocalRecording(audioTrack);
                }
            });
            this.stream = new MediaStream([
                ...this.audioDestination?.stream.getAudioTracks() || [],
                ...this.recordVideos().getTracks()
            ]);
        }
        this.recorder = new MediaRecorder(this.stream, {
            mimeType: this.mediaType,
            videoBitsPerSecond: VIDEO_BIT_RATE
        });
        this.recorder.addEventListener('dataavailable', e => {
            if (e.data && e.data.size > 0) {
                this.recordingData.push(e.data);
                this.totalSize -= e.data.size;
                if (this.totalSize <= 0) {
                    dispatch(stopLocalVideoRecording());
                }
            }
        });
        if (!onlySelf) {
            this.recorder.addEventListener('stop', () => {
                this.stream?.getTracks().forEach((track) => track.stop());
                cancelAnimationFrame(this.paintID);
            });
            this.stream.addEventListener('inactive', () => {
                dispatch(stopLocalVideoRecording());
            });
        }
        this.recorder.start();
    },
    /**
     * Whether or not we're currently recording locally.
     *
     * @returns {boolean}
     */
    isRecordingLocally() {
        return Boolean(this.recorder);
    }
};
export default LocalRecordingManager;
